import { Component, OnDestroy, ViewChild } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { interval, Subscription } from 'rxjs';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { ConfigService } from 'src/app/share/services/config.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
    selector: 'app-forget',
    templateUrl: './forget.component.html',
    styleUrls: ['./forget.component.scss'],
    standalone: false
})
export class ForgetComponent implements OnDestroy {
  @ViewChild('forgetForm', { static: false }) forgetForm: DxFormComponent;

  msg: string = '';
  messageTimeout: number;

  forgetFormData: any = {};
  isSending: boolean = false;
  isSended: boolean = false;
  cntDown: number = 8;
  subscription: Subscription;

  constructor(
    private apiService: ApiService,
    private languageService: LanguageService,
    public configService: ConfigService,
    private urlService: UrlService
  ) {}

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onClickReset = () => {
    this.onReset();
  };

  onClickForget = () => {
    this.msg = '';
    const validate = this.forgetForm.instance.validate();
    if (validate.isValid) {
      this.isSending = true;

      this.apiService.post(RouteKeys.Extern.Register.send_password_link, this.forgetFormData).subscribe({
        next: (response) => {
          this.isSending = false;
          this.isSended = true;
          this.subscription = interval(1000).subscribe((x) => {
            if (this.cntDown > 0) {
              this.cntDown--;
            }
          });
          setTimeout(() => {
            this.urlService.naviToPreserveQueryParams('extern/login');
          }, 8000);
        },
        error: (err) => {
          this.isSending = false;
          let _err;

          if (err.error || err.Error) {
            const ___err = err.error || err.Error;
            if (___err.message || ___err.Message) {
              _err = ___err.message || ___err.Message;
            } else {
              _err = ___err;
            }
          } else if (err.message || err.Message) {
            _err = err.message || err.Message;
          } else if (err.title || err.Title) _err = err.title || err.Title;
          else {
            _err = err;
          }

          this.msg = this.languageService.translate('mailError');
          throw _err || 'Server-Fehler';
        },
      });
    }
  };

  onReset() {
    this.forgetForm.instance.resetValues();
    this.urlService.naviToPreserveQueryParams('extern/start');
  }
}
